/* Quick-help links select a message topic. Delivery stays with Shopify's native form. */
(() => {
  if (window.medContactLinksReady) return;
  window.medContactLinksReady = true;
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-med-contact-topic]');
    if (!link) return;
    const root = link.closest('[data-med-contact]');
    const select = root?.querySelector('[data-med-contact-select]');
    if (!select || ![...select.options].some(option => option.value === link.dataset.medContactTopic)) return;
    event.preventDefault();
    select.value = link.dataset.medContactTopic;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    select.closest('form').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    select.focus({ preventScroll: true });
  });
})();
